import type { OperationModalProps } from '@atlassian/jira-directory-base/src/model';
import EditModal from '@atlassian/jira-edit-filters-modal/src';
import type { Filter } from '@atlassian/jira-filters-common/src/model';
import { connect } from '@atlassian/jira-react-redux';
import type { OperationData } from '@atlassian/jira-shareable-entity-dialog/src';
import { getBaseUrl } from '../../../state/selectors/app';

import { getName, getDescription, getEdits, getShares } from '../../../state/selectors/filters';
import type { State } from '../../../state/types';

export default connect(
	(state: State, ownProps: OperationModalProps<Filter>) => ({
		baseUrl: getBaseUrl(state),
		id: ownProps.entityId,
		name: getName(state, ownProps.entityId),
		description: getDescription(state, ownProps.entityId),
		// owner: getOwner(state, ownProps.entityId), // send only when backend supports changing owner
		sharePermissions: getShares(state, ownProps.entityId),
		editPermissions: getEdits(state, ownProps.entityId),
		onCancel: ownProps.onCancel,
		onInitiateSuccess: () => {
			ownProps.onDialogShown();
		},
		// TODO EM-575 remove comment
		// onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
		onEdited: (_updatedData: OperationData) => {
			// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
			ownProps.onUpdated();

			/* TODO EM-575
        const { name, description, sharePermissions } = updatedData;
        ownProps.onUpdated({
            patch: {
                name,
                description,
                shares: sharePermissions,
            },
        }); // updates main page. .onUpdated() will reload it instead, which we want to avoid
        // do same as is done in .onUpdated() or .onCancel() - to close modal */
		},
	}),
	{},
)(EditModal);
